import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';

export default function useInvoiceSFTPConfigHook(type = 'PV') {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    ftpHost: null,
    ftpUser: null,
    ftpPass: null,
    fileFormat: null,
    filePrefix: null,
    fileSufix: null,
    ftpDirPath: null,
    ftpFiles: 0,
    ftpErrors: 0,
    ftpResult: [],
    testFile: null,
    isValidation: false,
    isFileList: false,
    dateSelected: null,
    ftpfileValidationError: null,
    extension: null,
    sourcePms: null,
  });

  useEffect(() => {
    const fetchConfig = async () => {
      await actions.loadInvoiceSFTPConfig();
    };
    fetchConfig();
  }, [appState.selectedHotel]);

  const actions = {
    loadInvoiceSFTPConfig: async () => {
      try {
        updateState({ isLoading: true });
        const res = await API.getInvoiceSFTP(getSelectedHotel()?.key);

        const invoiceConfig = res?.sftpCredentials || {};

        const file = invoiceConfig?.fileFormat || '';
        const extension = file ? file.substring(file.lastIndexOf('.')) : '.xml';
        const fileWithoutExtension = file
          ? file.substring(0, file.lastIndexOf(extension))
          : 'YYYY-MM-DD';
        const filePrefix = invoiceConfig?.filePrefix || '';
        const fileSufix = invoiceConfig?.fileSufix || '';
        const sourcePms = invoiceConfig?.sourcePms || 'Opera';

        updateState({
          isLoading: false,
          fileFormat: fileWithoutExtension,
          extension,
          ftpHost: invoiceConfig?.ftpConfig?.host || '',
          ftpUser: invoiceConfig?.ftpConfig?.user || '',
          ftpPass: invoiceConfig?.ftpConfig?.password || '',
          ftpPort: invoiceConfig?.ftpConfig?.port || '',
          ftpDirPath: invoiceConfig?.ftpDirPath || '',
          filePrefix,
          fileSufix,
          sourcePms,
        });
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },

    onCheckConnection: async () => {
      try {
        updateState({ isLoading: true });

        const res = await API.checkInvoiceSFTPConnection({
          hotelId: getSelectedHotel()?.key,
          host: state.ftpHost,
          username: state.ftpUser,
          password: state.ftpPass,
          port: parseInt(state.ftpPort),
          folder: state.ftpDirPath,
        });

        updateState({
          isLoading: false,
          ftpFiles: res?.files && res?.files?.length > 0 ? res?.files : [],
          isValidation: false,
          isFileList: true,
        });

        notification.success({
          message: translate('policeReport.checkConnectionSuccess'),
        });
      } catch (err) {
        updateState({
          isLoading: false,
          ftpFiles: [],
          ftpResult: [],
          isValidation: false,
          isFileList: true,
        });
        notification.error({
          message: translate('policeReport.checkConnectionError'),
        });
      }
    },

    onSaveFTPConfig: async () => {
      try {
        updateState({ isLoading: true });

        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });

        await API.saveInvoiceSFTP(getSelectedHotel()?.key, hotelData.atlasId, 'active', {
          provider: constants.BOOKING_PROVIDER.SFTP,
          ftpConfig: {
            host: state.ftpHost,
            user: state.ftpUser,
            password: state.ftpPass,
            port: state.ftpPort,
          },
          fileFormat: state.fileFormat + state.extension,
          filePrefix: state.filePrefix,
          fileSufix: state.fileSufix,
          ftpDirPath: state.ftpDirPath,
          sourcePms: state.sourcePms,
        });

        notification.success({
          message: translate('policeReport.saveConfigSuccess'),
        });

        // Call check connection action
        await actions.onCheckConnection();
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({
          message: translate('policeReport.ftpError'),
        });
      }
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },

    isAdmin: () => {
      return !!appState?.superUser;
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
